import * as Yup from 'yup';

import capsuleValidation from 'src/app/utils/capsuleValidation';
import { FORM_VALIDATION_ERRORS } from 'src/consts';

const defaultValues = {
  street: '',
  street_two: '',
  zip_code: '',
  notes: '',
  is_doorman: false,
};

const schema = Yup.object().shape({
  street: Yup.string().required(FORM_VALIDATION_ERRORS.streetOne),
  street_two: Yup.string(),
  zip_code: capsuleValidation.zip().required(FORM_VALIDATION_ERRORS.zip),
  notes: Yup.string(),
  is_doorman: Yup.boolean().required(FORM_VALIDATION_ERRORS.doorman),
});

const validation = {
  schema,
  defaultValues,
};

export default validation;
